import type { AnalyticsDateRange } from "../hooks/useAnalyticsDashboard";

export function isIsoDate(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(value);
}

export function isValidAnalyticsDateRange(range: AnalyticsDateRange): boolean {
  return (
    isIsoDate(range.date_from) &&
    isIsoDate(range.date_to) &&
    range.date_from <= range.date_to
  );
}

/** When one bound moves past the other, align the opposite bound. */
export function correctAnalyticsDateRange(
  next: AnalyticsDateRange,
  changedField: keyof AnalyticsDateRange
): AnalyticsDateRange {
  if (
    changedField === "date_from" &&
    isIsoDate(next.date_to) &&
    next.date_from > next.date_to
  ) {
    return { ...next, date_to: next.date_from };
  }
  if (
    changedField === "date_to" &&
    isIsoDate(next.date_from) &&
    next.date_to < next.date_from
  ) {
    return { ...next, date_from: next.date_to };
  }
  return next;
}
